/* eslint-disable eag/match-named-export */
import {createContext} from 'shared/web';

import {Device} from '../../types/Device';

export const [DeviceContextProvider, useDevice] = createContext<Device>({
  strict: true,
  name: 'DeviceProvider',
});
